/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Hasan's Portfolio",
  description: "",
  og: {
    title: "Md Abul Hasan Portfolio",
    type: "website",
    url: "http://ashutoshhathidara.com/",
  },
};

//Home Page
const greeting = {
  title: "Hasan",
  logo_name: "Hasan",
  nickname: "",
  subTitle:
    "Software Developer experienced in C#, TypeScript React and Asp.Net Bringing life to your web applications",
  resumeLink:
    "https://drive.google.com/file/d/1Gjrm9ZF2PJ_Tp9zUIM85z7muNeBuFwIY/view?usp=drive_link",
  portfolio_repository: "https://github.com/hasanmd91",
  githubProfile: "https://github.com/hasanmd91",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/hasanmd91",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/hasanmd91/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:hasansas008@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Facebook",
    link:
      "https://www.facebook.com/profile.php?id=100069593825824&locale=fi_FI",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React-Redux",
        "⚡ Creating application backend in Asp .Net and C#",
        "⚡ Implementing automated testing with tools like Jest for React components and XUnit for backend services",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "dotnet",
          fontAwesomeClassname: "simple-icons:dotnet",
          style: {
            color: "#512bd4",
          },
        },
        {
          skillName: "Csharp",
          fontAwesomeClassname: "simple-icons:csharp",
          style: {
            color: "#512bd4",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Configuring and managing Azure App Services for deploying and scaling web applications",
        "⚡ Setting up Azure SQL Database or Azure Cosmos DB for efficient data storage and retrieval",
        "⚡ Implementing Azure Active Directory for secure authentication and access control",
        "⚡ Utilizing Azure DevOps for continuous integration and continuous deployment (CI/CD) pipelines",
      ],
      softwareSkills: [
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },

        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/hasanmd91/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/hasanmd1991",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/hasanmd1991",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@hasanmd1991",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Helsinki Business College",
      subtitle: "FullStack Software Developement",
      logo_path: "bc.png",
      alt_name: "Helsinki_business_college",
      duration: "2022 - 2023",
      descriptions: [
        "⚡ Successfully developed complex web applications using JavaScript and TypeScript, demonstrating fluency in data structures, algorithms, and object-oriented programming principles. Built RESTful APIs using Express.js for efficient backend communication.",
        "⚡ Designed and implemented database schemas for multiple real-world projects using MySQL and PostgreSQL, optimizing queries for efficient data retrieval and manipulation. Gained experience with MongoDB and Firebase as well.",
        "⚡ Understood and employed deployment processes using tools like Docker, Kubernetes, AWS, and Heroku. Successfully deployed and managed real-world applications on AWS and Heroku.",
        "⚡ Collaborated effectively with a team of developers on a client project, contributing to the successful design, development, and deployment of a secure and scalable web application. Utilized project management tools and agile methodologies to ensure smooth progress and communication.",
      ],
      website_link: "https://en.bc.fi/",
    },
    {
      title: "Savonia University of Applied Science",
      subtitle: "Bachelor of Business Administration",
      logo_path: "savonia.png",
      alt_name: "Savonia University of Applied Science",
      duration: "2011 - 2015",
      descriptions: [
        "⚡ I have taken a variety of courses related to Marketing, Logistics, and International Business Management",
        "⚡ Additionally, I conducted a thesis on determining the competitiveness of Bangladesh garment factories",
        "⚡ I am proficient in using various software tools and platforms relevant to my field, enhancing my efficiency in tasks such as data analysis, project management, and digital marketing strategies",
        "⚡ During my time at university, I was involved with the multimedia department where I worked on documentary films and interviews",
      ],
      website_link: "https://www.savonia.fi/en/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "FullStack Open",
      subtitle: "- Helsinki Univerisity",
      logo_path: "university-of-helsinki-logo.png",
      certificate_link:
        "https://studies.cs.helsinki.fi/stats/api/certificate/fullstackopen/en/207c234ee8bad58f6294b302bea96fc4",
      alt_name: "Helsinki University",
      color_code: "#ffff",
    },
    {
      title: "FullStack Open TypeScript",
      subtitle: "- Helsinki Univerisity",
      logo_path: "university-of-helsinki-logo.png",
      certificate_link:
        "https://studies.cs.helsinki.fi/stats/api/certificate/fs-typescript/en/110833417acb0e7855bb05e9b5d8aea0",
      alt_name: "Helsinki University",
      color_code: "#ffff",
    },
    {
      title: "FullStack Software Developemnt Training",
      subtitle: "- Integrify",
      logo_path: "integrify.png",
      certificate_link:
        "https://drive.google.com/file/d/1DUqMQ4IIQmCMjd1ouF0YAmJbt88uiPP8/view?usp=sharing",
      alt_name: "integrify",
      color_code: "#ffff",
    },
    {
      title: "AWS Technical Essentials",
      subtitle: "- Amazon Web Services (AWS)",
      logo_path: "aws.png",
      certificate_link:
        "https://drive.google.com/file/d/1h4m4wI-UgCE4xtJvf5QUdrSfEEnSQy_y/view?usp=sharing",
      alt_name: "aws",
      color_code: "#ffff",
    },
    {
      title: "Getting Started with DevOps on AWS",
      subtitle: "- Amazon Web Services (AWS)",
      logo_path: "aws.png",
      certificate_link:
        "https://drive.google.com/file/d/1h4m4wI-UgCE4xtJvf5QUdrSfEEnSQy_y/view?usp=sharing",
      alt_name: "aws",
      color_code: "#ffff",
    },
    {
      title: "The Modern Javascript Bootcamp Course",
      subtitle: "- Udemy",
      logo_path: "udemy.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-be0712a1-2ddd-43cd-bb6a-8007869c4213",
      alt_name: "udemy",
      color_code: "#ffff",
    },
    {
      title: "Build Responsive Real-World Websites with HTML and CSS",
      subtitle: "- Udemy",
      logo_path: "udemy.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-6bdd4da5-f257-48cb-8405-281cb34d1586",
      alt_name: "udemy",
      color_code: "#ffff",
    },

    {
      title: "Redux Course Lws",
      subtitle: "- Lws",
      logo_path: "lws.png",
      certificate_link:
        "https://drive.google.com/file/d/1NqMSyXpl86-pPxMuVwbvqy3L1_4AiGbv/view?usp=sharing",
      alt_name: "lws",
      color_code: "#ffff",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "With each project, I push my work to new horizons, always putting quality first.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Software Developer Trainee",
          company: "Quanturi Oy",
          company_url: "https://legatohealthtech.com/",
          logo_path: "quanturi.png",
          duration: "April 2023 - August 2023",
          location: "Helsinki Finalnd",
          description:
            "I develop code according to software requirements and specifications. This involves identifying and resolving software defects, bugs, and technical issues. I thoroughly test the code through unit testing and integration testing to ensure its functionality and reliability. Throughout the development process, I meticulously document software functionality, code changes, and technical specifications to maintain clear and comprehensive records. Additionally, I actively participate in software testing activities, collaborating with the team to ensure the quality and performance of the software product.",
          color: "#0879bf",
        },
        {
          title: "Automated Logistics Operator",
          company: "Inex Partners Oy",
          company_url: "https://inex.fi/",
          logo_path: "inex.png",
          duration: "November 2017 - August 2022",
          location: "Sipoo, Finland",
          description:
            "I support daily operations by effectively resolving technical and operational system faults. This involves working closely with the maintenance team to guarantee optimal performance and maintenance of machines. I check, control, diagnose, and maintain the proper functioning of automation systems to ensure smooth operation. Additionally, I contribute to the optimization of production operations, leading to increased efficiency and productivity.",
          color: "#9b1578",
        },
      ],
    },
    {
      title: "Training",
      experiences: [
        {
          title: "Full Stack Software Developer",
          company: "Integrify",
          company_url: "https://www.integrify.io",
          logo_path: "integrify.png",
          duration: "August 2023 - February 2024",
          location: "Helsinki, Finaland",
          description:
            "I have completed comprehensive training in full-stack software development at Integrify, where I acquired proficiency in creating professional frontend applications using React. Additionally, I gained expertise in backend development utilizing C# and the ASP.NET framework, along with PostgreSQL as the preferred database server. Moreover, I have hands-on experience with Azure databases and deploying applications in virtual machines, acquired during the DevOps module of the training program.",
          color: "#000000",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Full stack projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "Hasan.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you, Asp.Net React, Cloud and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://hasnewsdotme.blogspot.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Otavantie 10 00200 Helsinki",
    locality: "Helsinki",
    country: "Fi",
    region: "Uusimaa",
    postalCode: "00200",
    streetAddress: "Otavantie 10",
    avatar_image_path: "address_image.svg",
    location_map_link:
      "https://www.google.com/maps/place/Otavantie+10,+00200+Helsinki/@60.1593197,24.8769508,17z/data=!3m1!4b1!4m6!3m5!1s0x46920a5d12c40b8b:0xfbef1977450af206!8m2!3d60.1593171!4d24.8795257!16s%2Fg%2F11c88_ycmc?entry=ttu",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
